export default "__VITE_ASSET__gzgqNSeQ__"